import { Box, Button, Chip, Grid, Link, Typography } from "@mui/material";
import React from "react";

import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";
import DynamicPageLayout from "../common/DynamicPageLayout";
import { useAccessionDetails } from "./useAccessionDetails";

const AccessionDetails: React.FunctionComponent<any> = () => {
  const navigate = useNavigate();
  const { accessionDetailsContentJson, timeLineDetails } =
    useAccessionDetails();

  return (
    <>
      <Box className="backBtnWrap">
        <Button
          startIcon={<ArrowBackIosNewRoundedIcon />}
          size="small"
          onClick={() => navigate(`/accessions/`)}
        >
          Back
        </Button>
      </Box>
      <Grid container spacing={2} mb={2}>
        <Grid item xs>
          <Typography
            variant="h4"
            gutterBottom
            className="dFlex alignItemsCenter"
          >
            Accession 9002 &nbsp;
            <Chip label="Created" color="info" variant="outlined" />
          </Typography>
        </Grid>
        <Grid item justifyContent="flex-end">
          &nbsp;
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item md={3}>
          <DynamicPageLayout
            pageContentJson={accessionDetailsContentJson}
            data={{}}
          />
        </Grid>
        <Grid item md={9}>
          <Box>
            <Typography variant="h6" gutterBottom>
              Order Journey
            </Typography>

            <TableContainer>
              <Table
                aria-label="simple table"
                stickyHeader
                sx={{
                  "& .MuiTableCell-body": {
                    borderBottom: "none",
                  },
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell>&nbsp;</TableCell>
                    <TableCell>
                      <strong>Step</strong>
                    </TableCell>
                    <TableCell>
                      <strong>By</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Date</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Location</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Info/Alert</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {timeLineDetails.map((item, index) => (
                    <TableRow
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                      key={index}
                    >
                      <TableCell className="connected">
                        <CheckCircleIcon color="success" />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <strong>{item.step}</strong>
                      </TableCell>
                      <TableCell>{item.by}</TableCell>
                      <TableCell>{item.date}</TableCell>
                      <TableCell>
                        <Chip
                          label={item.locationId}
                          variant="outlined"
                          color="info"
                          size="small"
                        />{" "}
                        &nbsp;{item.locationName}
                      </TableCell>
                      <TableCell>
                        UPS Tracking:
                        <br />
                        <Link>1237493023030382</Link>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default AccessionDetails;
